import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { CustomTitle, VisorComponent } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { TablasDinamicasConfigService } from '../../../services/database/tablas-dinamicas-config.service';

@Component({
  selector: 'app-dataset-visualizar-documentos',
  standalone: true,
  imports: [DialogModule, CustomTitle, TranslateModule, TabViewModule, CommonModule],
  template: `
  <section>
    <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
      [resizable]="true" [maximizable]="true"  
      [breakpoints]="{'960px': '100vw'}" [style]="{width: '70vw'}" >
      <ng-template pTemplate="header">
        <CustomTitle [title]="'common.documentos' | translate" />
      </ng-template>
      <ng-template pTemplate="content">
        <p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
          <p-tabPanel *ngFor="let tab of data; let i = index" [header]="tab.name">
            <ng-container *ngIf="tab.loaded && tab.blob; else loading">
              <iframe [src]="getSafeUrl(tab.blob)" style="width: 100%; height: 600px; border: none;"></iframe>
            </ng-container>
            <ng-template #loading>
              <div class="flex justify-content-center align-items-center" style="min-height: 200px;">
                <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                <span class="ml-2">Cargando documento...</span>
              </div>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </ng-template>
      <ng-template pTemplate="footer">
      </ng-template>
    </p-dialog>
</section>
  ` 
})
export class DatasetVisualizarDocumentosComponent {

  displayModal: boolean = false;
  data!: any[];
  tablaDinamicaConfigId!: number;
  filaId!: number;
  fieldName!: string;
  activeIndex: number = 0;

  @ViewChild('visor') visorDialog !: VisorComponent;

  constructor(
    private readonly _tsc: TablasDinamicasConfigService,
    private readonly sanitizer: DomSanitizer
  ) { }

  openModal(tablaDinamicaConfigId: number, filaId: number, fieldName: string, data: any[]): void {
    this.displayModal = true;
    this.tablaDinamicaConfigId = tablaDinamicaConfigId;
    this.filaId = filaId;
    this.fieldName = fieldName;
    this.data = data;
    this.activeIndex = 0;
    
    if (this.data && this.data.length > 0) {
      this.loadDocument(0);
    }
  }

  closeModal(): void {
    this.displayModal = false;
  }

  onTabChange(event: any): void {
    const index = event.index;
    if (!this.data[index].loaded) {
      this.loadDocument(index);
    }
  }

  getSafeUrl(blob: Blob): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
  }

  private async loadDocument(index: number): Promise<void> {
    const tab = this.data[index];    
    this._tsc.descargarDocumentoFormulario(this.tablaDinamicaConfigId, this.filaId, this.fieldName, tab.file).subscribe({
      next: (blob: Blob) => {
        tab.blob = blob;
        tab.loaded = true;
      },
    });  
  }
}
